import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import UserApi from '@/api/user'
import { headAccess } from '@/utils/userType'

@Module
export default class AuthModule extends VuexModule {
    public token: string = localStorage.getItem('user-token') || ''
    public isLoading: boolean = false
    public message: string = ''
    public canRunQueries: boolean = false

    get authenticationType(): string {
        const jwt = this.token
        if (jwt) {
            const payload = jwt.split('.')[1]
            const strJSON = atob(payload)
            const json = JSON.parse(strJSON)
            return json.type
        }
        return ''
    }

    @Action
    public async updateCanRunQueries() {
        const result = await UserApi.canRunQueries()
        const canRunQueries: boolean = result.data?.canRunQueries ? true : false

        this.context.commit('setCanRunQueries', canRunQueries)
    }

    get isAuthenticated(): boolean {
        return this.token.length > 0
    }

    get hasError(): boolean {
        return this.message !== ''
    }

    get canUpdateApps(): boolean {
        return headAccess.includes(this.authenticationType)
    }

    @Mutation
    public setToken(token: string) {
        this.token = token
        localStorage.setItem('user-token', token)
    }

    @Mutation
    public setLoading(loading: boolean) {
        this.isLoading = loading
        if (loading) {
            this.message = ''
        }
    }

    @Mutation
    public setError(message: string) {
        this.message = message
    }

    @Mutation
    public setCanRunQueries(value: boolean) {
        this.canRunQueries = value
    }

    @Action
    public async doLoginWithGoogle(credentials: GoogleLoginCredentialEntity) {
        this.context.commit('setLoading', true)

        const response = await UserApi.postGoogleLogin(credentials)
        if (response.status !== 'success') {
            this.context.commit('setError', response.message)
        } else {
            this.context.commit('setToken', response.data!.token)
        }

        this.context.commit('setLoading', false)
    }

    @Action
    public doLogout() {
        this.context.commit('setToken', '')
        this.context.commit('setLoading', false)
        this.context.commit('setError', '')
    }
}
